import { useBrokersServiceBrokersUsersRetrieve } from '@insurance/api/queries'
import { BrokerUser } from '@insurance/api/requests'
import { useMemo } from 'react'

import { AgentActionsTypes, CommonPropsAgent } from './types'
import { modalsActions } from './utils'

type Props = {
  type: AgentActionsTypes
  data?: BrokerUser
} & Omit<CommonPropsAgent, 'data'>

export const AgentsActions = ({ type, data, ...props }: Props) => {
  const Component = useMemo(() => modalsActions[type], [type])

  const { data: agent, isLoading: isAgentLoading } =
    useBrokersServiceBrokersUsersRetrieve({ id: Number(data?.id) }, undefined, {
      enabled: !!data?.id && !!Component
    })

  if (!Component) return null

  return <Component data={agent} loading={isAgentLoading} {...props} />
}
